import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import replace from "string-replace-to-array";
import clsx from "clsx";
import styles from "../../../styles/components/results.module.scss";
import { alert, alertWarning, alertReset } from "../../../styles/components/alert.module.scss";
import ArtCard from "./card/ArtCard";
import ResetButton from "./ResetButton";
import VehicleCard from "./card/VehicleCard";

function SearchResult({ data, resetHandler }) {
  const [cards, setCards] = useState([]);
  const isLoad = useSelector(({ searchReducer }) => searchReducer.isLoad);
  const wishList = useSelector(({ wishListReducer }) => wishListReducer.wishList);
  // eslint-disable-next-line max-len
  const {
    searchNoResults, searchPostType, alertIndex, alertThumbnail, alertUrl, alertTitle, alertText, alertBtnText,
  } = useSelector(({ rootReducer }) => rootReducer.baseSettings);
  let wishlist = document.getElementById("js-lg-wishlist");

  /**
     * Inserts an alert card on a specified spot.
     * Or doesn't if the alertIndex is not a valid number.
     */
  useEffect(() => {
    const index = Number(alertIndex);

    if (data && data.length) {
      // eslint-disable-next-line max-len
      if (!Number.isNaN(index) && alertIndex !== "" && alertUrl !== "" && alertTitle !== "" && alertBtnText !== "") {
        const modifiedCards = [...data];
        modifiedCards.splice(index, 0, "alert");
        setCards(modifiedCards);
      } else {
        setCards(data);
      }
    }
  }, [data, alertIndex, isLoad]);

  if (data && !data.length && searchNoResults) {
    const searchNoResultsArray = replace(
      searchNoResults,
      /(reset)/g,
            <ResetButton resetText={"reset"} resetHandler={resetHandler} className={`${alertReset}`}/>,
    );
    return (
            <div className={`${styles.noResults}`} role="alert">
                <div className={`${alert} ${alertWarning}`} role="alert">
                    {typeof searchNoResultsArray !== "undefined" && searchNoResultsArray.map((item, key) => {
                      if (typeof item === "string") {
                        return (
                                <span key={key} dangerouslySetInnerHTML={{ __html: item }}/>
                        );
                      }
                      return item;
                    })}
                </div>
            </div>
    );
  }

  // const componentList = {
  //     'product': (...args) => <ProductCard {...args}/>
  // }

  const getComponent = ({
    searchPostType, index, wishListID, result, total,
  }) => {
    if (searchPostType === "car") {
      return <VehicleCard key={index} isFavour={wishListID} result={result} index={index}
                                                      total={total}/>;
    }
    if (searchPostType === "museum_art") {
      return <ArtCard key={index} isFavour={wishListID} result={result}
                                                             index={index} total={total}/>;
    }
  };

  const getClass = ({ styles, searchPostType }) => {
    if (searchPostType === "car") return;
    if (searchPostType === "museum_art") return styles.artCards;
  };

  return (
        <>
            <ul className={clsx(`mus-results ${searchPostType} ${getClass({
              styles,
              searchPostType,
            })} ${styles.cards}`, !isLoad && styles.resultCardsAnimation)}>
                {cards.map((result, index) => {

                  const total = cards.length;
                  const wishListID = wishList[result.ID];

                  return getComponent({
                    searchPostType, index, wishListID, result, total,
                  });
                })}
            </ul>
        </>
  );
}

export default SearchResult;
